<template>
  <div id="app" @mouseup="handleMouseUp">
    <component v-bind:is="layout"></component>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import PublicLayout from './components/PublicLayout'
  import PrivateLayout from './components/PrivateLayout'
  import {PRIVATE_LAYOUT, PUBLIC_LAYOUT} from "./constants/layout-constants";
  import { SESSION_TIME } from '@/config';
  import { RESET_TIMER } from '@/constants/event';
  import { ping } from '@/api/sessionApi';
  import { LogoutRequest } from '@/store/modules/fsm/messages';
  import { post } from '@/store/modules/fsm/index';

  export default {
    name: 'App',
    computed: {
      ...mapGetters('login',{
        isLoggedIn: 'isLoggedIn'
      }),
      layout() {
        if (this.isLoggedIn)
          return PRIVATE_LAYOUT;
        else
          return PUBLIC_LAYOUT;
      }
    },
    components: {
      'public-layout': PublicLayout,
      'private-layout': PrivateLayout,
    },
    methods: {
      // this tells the server that the client side is active
      handleMouseUp() {
        if (this.$store.getters['login/isLoggedIn']) {
          ping()
          .then(() => {
            // console.log(`${new Date().toLocaleString()}: pong\n`);
          })
          .catch((err) => {
            console.error(err);
          })
        }
      }
    },
    mounted() {
      // check activity/pulse
      this.$vueEventBus.$on(RESET_TIMER, (info) => {
        // clear timer
        if (this.$sessionTimer) {
          clearTimeout(this.$sessionTimer);
        } 
        // set timer
        this.$sessionTimer = setTimeout(()=>{
          if (this.$store.getters['login/isLoggedIn'] && info.ping) {
            ping()
            .then(() => {

              console.log(`${new Date().toLocaleString()}: pong\n`);
            })
            .catch((err) => {
              // NOTE: timeout is handled in the base request service
              console.error(err);
            })
          }
        },SESSION_TIME);
      });
    },
    beforeDestroy() {
      clearTimeout(this.$sessionTimer);
      this.$vueEventBus.$off(RESET_TIMER);
    },
  }
</script>

<style>
  html {
    position: relative;
    min-height: 100%;
  }
  #app {
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* overflow: hidden; */
  }
  .page {
    padding-top: 2.0rem;
    padding-bottom: 8.0rem;
    /* min-height: 90vh; */
  }
  .void-filler {
    margin-top: 10%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 2em;
  }
  .container {
    /* max-width: 1000px; */
    max-width: 95vw;
  }
  .fa-disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .file-upload-controls {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-right: 1em;
  }
</style>
